// @flow

import { all, put, takeEvery, call } from "redux-saga/effects";
import type { Action } from "redux-action";
import http from "@http";
import config from "@config";
import { GetAppClientSettings, UpdateAppClientSettings } from "@modules/client/constants/actions";
import actionCreators from "@modules/client/actionCreator";
import type { AppConfiguration } from "@modules/client/reducer/app/types";
import { parseSchema } from "@utils/schema";
import { sendSuccessMessage } from "@modules/app/actionCreator";

type AppRequest = {
  clientId: string,
};

export function* onGetAppClientSettings({ payload }: Action<AppRequest>): Generator<*, void, *> {
  try {
    if (!payload || !payload.clientId) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(
      http.get,
      `${config.endpointBaseUrl}api/v1/service-admin/client/${payload.clientId}/service-config/absence-management/client-app-settings`,
    );

    yield put(actionCreators.GetAppClientSettingsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetAppClientSettingsError(e.response));
  }
}

type UpdateAppRequest = {
  clientId: string,
  data: AppConfiguration,
};

export function* onUpdateAppClientSettings({
  payload,
}: Action<UpdateAppRequest>): Generator<*, void, *> {
  try {
    if (!payload || !payload.clientId || !payload.data) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(
      http.put,
      `${config.endpointBaseUrl}api/v1/service-admin/client/${payload.clientId}/service-config/absence-management/client-app-settings`,
      payload.data,
    );

    yield put(actionCreators.UpdateAppClientSettingsSuccess(response.data));
    yield put(sendSuccessMessage("SETTINGS_UPDAtED"));
  } catch (e) {
    yield put(actionCreators.UpdateAppClientSettingsError(e.response));
  }
}

export function* AppSagas(): Generator<*, void, void> {
  yield all([
    takeEvery(GetAppClientSettings, onGetAppClientSettings),
    takeEvery(UpdateAppClientSettings, onUpdateAppClientSettings),
  ]);
}

export default AppSagas;
